import React, {useEffect, useState} from 'react';
import 'primereact/resources/primereact.min.css';
import ProfileMenu from "../Menu/ProfileMenu";
import InlineProfileMenu from "../Menu/InlineProfileMenu";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {setActiveClick} from "../../redux/actions/actions";
import {DEV, STAGE} from "../../redux/config";
import {getHashPath} from "../../utils/encodedUrlQuery";


const CompaniesHeader = (props: any) => {
    const dispatch = useAppDispatch();
    const [profileMenuActive, setProfileMenuActive] = useState(false);
    const loader = useAppSelector(state => state.MonitoringListReducer.loading);
    const queueLoader = useAppSelector(state => state.QueueListReducer.loading);
    // @ts-ignore
    const usersLoader = useAppSelector(state => state.UsersListReducer.loading);
    // @ts-ignore
    const companiesLoader = useAppSelector(state => state.CompaniesListReducer.loading);
    const skillGroupLoader = useAppSelector(state => state.QualificationGroupListReducer.loading);
    const rolesLoader = useAppSelector(state => state.RolesReducer.loading);
    const branchLoading = useAppSelector(state => state.BranchesListReducer.loading);
    const statusesLoader = useAppSelector(state => state.StatusesListReducer.loading);
    const trunksLoader = useAppSelector(state => state.TrunksListReducer.loading);
    const audioListLoader = useAppSelector(state => state.AudioListReducer.loading);
    const statisticListLoader = useAppSelector(state => state.StatisticsListReducer.loading);
    const statisticCallsListLoader = useAppSelector(state => state.StatisticsCallsListReducer.loading);
    const statisticStatusListLoader = useAppSelector(state => state.StatisticsStatusListReducer.loading);
    const trunkStatisticsListLoader = useAppSelector(state => state.TrunkStatisticsListReducer.loading);
    const recallNumberChanged = useAppSelector(state => state.WebRTCReducer.recallNumberChanged);
    const detailsLoading = useAppSelector(state => state.MonitoringListReducer.detailsLoading);
    // @ts-ignore
    const dialerDetailsLoading = useAppSelector(state => state.CompaniesListReducer.detailsLoading);
    const monitoringQueueLoader = useAppSelector(state => state.MonitoringListReducer.monitoringQueueLoader);
    const statusesByPeriodLoader = useAppSelector(state => state.StatusesByPeriodListReducer.loading);
    const contactsLoader = useAppSelector(state => state.CompaniesListReducer.contactsLoader)
    const ivrConfigurationDetailsLoader = useAppSelector(
        (state) => state.IVRConfigurationReducer.detailsLoading
    );
    const ivrConfigurationListLoader = useAppSelector(
        (state) => state.IVRConfigurationReducer.loading
    );
    const audioControlListLoader = useAppSelector(
        (state) => state.AudioControlListReducer.loading
    );
    const qualityControlStatisticsLoader = useAppSelector(
        (state) => state.QualityControlStatisticsReducer.loading
    );
    const profileMenuActiveChange = (active: any) => {
        // props.profileMenuPinClose(false);
        props.profileMenuPinChange(active)
        setProfileMenuActive(active);
    };

    useEffect(() => {
        props.profileMenuPinChange(true)
        setProfileMenuActive(true);
    }, [recallNumberChanged]);

    useEffect(() => {
        props.profileMenuPinChange(false)
        setProfileMenuActive(false);
    }, [])

    const loaders = {
        'Монiторинг Подiй': {isLoading: loader, reloadIcon: true},
        'Вхідні черги': {isLoading: queueLoader, reloadIcon: true},
        'Користувачі': {isLoading: usersLoader, reloadIcon: true},
        'Вихідні кампанії': {isLoading: companiesLoader, reloadIcon: true},
        'Групи кваліфікацій': {isLoading: skillGroupLoader, reloadIcon: true},
        'Ролі користувачів': {isLoading: rolesLoader, reloadIcon: true},
        'Branch': {isLoading: branchLoading, reloadIcon: true},
        'Статуси': {isLoading: statusesLoader, reloadIcon: true},
        'Транки': {isLoading: trunksLoader, reloadIcon: true},
        'Бібліотека аудіо': {isLoading: audioListLoader, reloadIcon: true},
        'Дані дзвінків': {isLoading: statisticListLoader, reloadIcon: true},
        'Дзвінки операторів': {isLoading: statisticCallsListLoader, reloadIcon: true},
        'Статуси операторів': {isLoading: statisticStatusListLoader, reloadIcon: true},
        'Статистика транка': {isLoading: trunkStatisticsListLoader, reloadIcon: true},
        'Деталі дзвінка': {isLoading: detailsLoading, reloadIcon: true},
        'Деталі кампанії': {isLoading: dialerDetailsLoading, reloadIcon: true},
        'Моніторинг Черг': {isLoading: monitoringQueueLoader, reloadIcon: true},
        'Статуси оператора': {isLoading: statusesByPeriodLoader, reloadIcon: true},
        'Ліди кампанії': {isLoading: contactsLoader, reloadIcon: true},
        "IVR Конфігурації": {isLoading: ivrConfigurationListLoader, reloadIcon: true},
        'IVR схема': {isLoading: ivrConfigurationDetailsLoader, reloadIcon: true},
        'Аудіоконтроль': {isLoading: audioControlListLoader, reloadIcon: true},
        'Контроль якості': {isLoading: qualityControlStatisticsLoader, reloadIcon: true},
    };

    const foundItem = props?.model?.find((item: { label: any; }) => item.label === props.title);
    const statisticSection = props?.model?.find((item: { name: string; }) => item.name === "Statistic");
    const settingSection = props?.model?.find((item: { name: string; }) => item.name === "Settings");
    const foundItemSettings = settingSection?.items?.find((item: { label: any; }) => item.label === props.title);
    const foundItemStatistics = statisticSection?.items?.find((item: { label: any; }) => item.label === props.title);

    // @ts-ignore
    return (
        <div className={`col-12 header ${DEV ? 'header-dev' : STAGE ? 'header-stage' : ''}`}>
            {/*<ul className={`lightrope cursor-pointer ${!props.animationEnabled ? "" : ""}`}>*/}
            {/*    {Array.from({ length: 50 }).map((_, index) => (*/}
            {/*        <li key={index} onClick={props.toggleAnimation}></li>*/}
            {/*))}*/}
            {/*</ul>*/}
            <div className="card topbar mb-0 pt-4">
                <div className="topbar-left-block align-items-center">
                    <div className="topbar-left-block-bg"></div>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="onLight" onClick={props.toggleAnimation}></a>
                    <div style={{minWidth: '30px'}} className="flex justify-content-end">
                        {Object.entries(loaders).map(([title, {isLoading, reloadIcon}], index) =>
                                props?.title === title && (
                                    isLoading ? (
                                        <div style={{marginTop: '2px'}} key={index}>
                                            <i className="pi pi-spin pi-spinner" style={{fontSize: '1.2rem'}}></i>
                                        </div>
                                    ) : reloadIcon && (
                                        <div style={{marginTop: '2px'}} key={index} className="cursor-pointer">
                                            <i className="pi pi-refresh" onClick={() => {
                                                const item =
                                                    props.customReloadClickItem ??
                                                    (foundItem?.to ||
                                                        foundItemSettings?.to ||
                                                        foundItemStatistics?.to ||
                                                        "/");
                                                dispatch(
                                                    setActiveClick({
                                                        item,
                                                        from: getHashPath(window.location.hash),
                                                        click: true,
                                                    })
                                                );
                                            }} style={{fontSize: '1.2rem'}}></i>
                                        </div>
                                    )
                                )
                        )}
                    </div>
                    <h5 className="topbar-title">
                        {props.headerDisplayTitle != null
                            ? props.headerDisplayTitle
                            : props.title === "Статуси"
                              ? "Статуси користувачів"
                              : props.title}
                        {STAGE && (
                            <span className="topbar-stage-warning">Увага ! Тестове середовище !</span>
                        )}
                    </h5>
                </div>
                <div className="layout-rightmenu-button-desktop">
                    <ProfileMenu isActiveTab={props.isActiveTab} setIsActiveTab={props.setIsActiveTab} animationEnabled={props.animationEnabled} statusHubConnectionState={props.statusHubConnectionState} profileMenuPin={props.profileMenuPin} profileMenuActive={profileMenuActive} onRightMenuPinChange={props.profileMenuPinChange} profileMenuActiveChange={profileMenuActiveChange}/>
                    <InlineProfileMenu isActiveTab={props.isActiveTab} setIsActiveTab={props.setIsActiveTab} statusHubConnectionState={props.statusHubConnectionState} isDesktop={props.isDesktop} showIconAsInactive={props.showIconAsInactive} profileMenuActiveChange={profileMenuActiveChange}/>
                </div>
            </div>
        </div>
    );
};

export default CompaniesHeader;
